/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styles from "./Styles.module.scss";
import { Breadcrumbs, Container, Grid, Link as BCLink, Box, Pagination, Chip, CircularProgress, Tooltip } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import axios from "../../axios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import usePermissionGuard from "../../hooks/usePermissionGuard";

const STATUS_COLORS = { toDo: "#f57c00", failed: "#e53935", inProgress: "#1565c0" };

const StoreFailedOrders = () => {
  usePermissionGuard("view_failed_orders");
  const [orders, setOrders] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => { fetch(); }, []);

  const fetch = (page = 0) => {
    setOrders(null);
    axios.get(`/admin/store/dashboard/failed-orders?page=${page}`)
      .then(r => setOrders(r.data.data))
      .catch(() => {});
  };

  const refresh = (_, page) => fetch(page);

  return (
    <div>
      <Container sx={{ pb: "2rem" }}>
        <div role="presentation">
          <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNext fontSize="small" />} sx={{ p: "14px 0" }}>
            <BCLink className={styles.brdHov} underline="none" color="inherit" href="/" fontSize="14px">{t("Home")}</BCLink>
            <BCLink className={styles.brdHov} underline="none" color="inherit" onClick={() => navigate("/store/dashboard")} sx={{ cursor: "pointer" }} fontSize="14px">Dashboard</BCLink>
            <BCLink underline="none" color="text.primary" aria-current="page" fontSize="14px">Failed Orders</BCLink>
          </Breadcrumbs>
        </div>

        {orders?.data?.length === 0 && (
          <div style={{ background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: 8, padding: "12px 16px", marginBottom: 16, fontSize: 14, color: "#2e7d32" }}>
            ✅ No failed orders — everything is processing correctly.
          </div>
        )}

        <Grid container item>
          {!orders ? (
            <Box sx={{ display: "flex", justifyContent: "center", width: "100%", pt: 4 }}>
              <CircularProgress sx={{ color: "#cc9966" }} />
            </Box>
          ) : orders.data.length === 0 ? null : (
            <table className={styles.table} style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Status</th>
                  <th>Tries</th>
                  <th>Last Error</th>
                  <th>Created</th>
                </tr>
              </thead>
              <tbody>
                {orders.data.map(fo => (
                  <tr key={fo.id}>
                    <td style={{ fontWeight: 500, fontFamily: "monospace", fontSize: 13 }}>{fo.order_id}</td>
                    <td>
                      <Chip label={fo.sync_status} size="small"
                        sx={{ background: (STATUS_COLORS[fo.sync_status] || "#999") + "20",
                             color: STATUS_COLORS[fo.sync_status] || "#999",
                             fontWeight: 600, fontSize: 11 }} />
                    </td>
                    <td style={{ fontSize: 13, color: "#555" }}>{fo.tries}</td>
                    <td style={{ fontSize: 12, color: "#777", maxWidth: 320 }}>
                      <Tooltip title={fo.last_message || ""} placement="top">
                        <span style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 300 }}>
                          {fo.last_message || "—"}
                        </span>
                      </Tooltip>
                    </td>
                    <td style={{ fontSize: 12, color: "#999", whiteSpace: "nowrap" }}>
                      {new Date(fo.created_at).toLocaleString("nl-NL")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          <Container sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
            <Pagination count={orders?.last_page || 0} page={orders?.current_page || 0} onChange={refresh} />
          </Container>
        </Grid>
      </Container>
    </div>
  );
};

export default React.memo(StoreFailedOrders);
